export function fetchImpressionsCount(state, { filter }) {
  return {
    ...state,
    impressionsReports: {
      ...state.impressionsReports,
      filter: filter || state.impressionsReports.filter,
      activeFetchingCounter: state.impressionsReports.activeFetchingCounter + 1,
      fetchingErrorMessages: [],
      isFetching: true,
    },
  };
}

export function fetchImpressionsCountSuccess(state, impressionsCount) {
  const fetchingCounter = state.impressionsReports.activeFetchingCounter - 1;
  return {
    ...state,
    impressionsReports: {
      ...state.impressionsReports,
      impressionsCount: impressionsCount.impressionsCount,
      servedCount: impressionsCount.servedCount,
      completedCount: impressionsCount.completedCount,
      clicksCount: impressionsCount.clicksCount,
      leadsCount: impressionsCount.leadsCount,
      earnings: impressionsCount.earnings,
      earningsTotal: impressionsCount.earningsTotal,
      activeFetchingCounter: fetchingCounter,
      isFetching: !(fetchingCounter === 0),
    },
  };
}

export function fetchImpressionsCountFail(state, error) {
  const fetchingCounter = state.impressionsReports.activeFetchingCounter - 1;
  const errorMessage =
    error.message ? error.message : 'Request failed. Open the browser console for details.';
  return {
    ...state,
    impressionsReports: {
      ...state.impressionsReports,
      activeFetchingCounter: fetchingCounter,
      isFetching: !(fetchingCounter === 0),
      fetchingErrorMessages: [...state.impressionsReports.fetchingErrorMessages, errorMessage],
    },
  };
}

export function fetchImpressionsAllCountries(state, { sort }) {
  return {
    ...state,
    impressionsReports: {
      ...state.impressionsReports,
      allCountries: {
        ...state.impressionsReports.allCountries,
        sort,
      },
      activeFetchingCounter: state.impressionsReports.activeFetchingCounter + 1,
      fetchingErrorMessages: [],
      isFetching: true,
    },
  };
}

export function fetchImpressionsAllCountriesSuccess(state, allCountries) {
  const fetchingCounter = state.impressionsReports.activeFetchingCounter - 1;
  return {
    ...state,
    impressionsReports: {
      ...state.impressionsReports,
      allCountries: {
        ...state.impressionsReports.allCountries,
        items: allCountries,
      },
      activeFetchingCounter: fetchingCounter,
      isFetching: !(fetchingCounter === 0),
    },
  };
}

export function fetchImpressionsAllCountriesFail(state, error) {
  const fetchingCounter = state.impressionsReports.activeFetchingCounter - 1;
  const errorMessage =
    error.message ? error.message : 'Request failed. Open the browser console for details.';
  return {
    ...state,
    impressionsReports: {
      ...state.impressionsReports,
      activeFetchingCounter: fetchingCounter,
      isFetching: !(fetchingCounter === 0),
      fetchingErrorMessages: [...state.impressionsReports.fetchingErrorMessages, errorMessage],
    },
  };
}

export function fetchImpressionsAllCampaigns(state, { sort }) {
  return {
    ...state,
    impressionsReports: {
      ...state.impressionsReports,
      allCampaigns: {
        ...state.impressionsReports.allCampaigns,
        sort,
      },
      activeFetchingCounter: state.impressionsReports.activeFetchingCounter + 1,
      fetchingErrorMessages: [],
      isFetching: true,
    },
  };
}

export function fetchImpressionsAllCampaignsSuccess(state, allCampaigns) {
  const fetchingCounter = state.impressionsReports.activeFetchingCounter - 1;
  return {
    ...state,
    impressionsReports: {
      ...state.impressionsReports,
      allCampaigns: {
        ...state.impressionsReports.allCampaigns,
        items: allCampaigns,
      },
      activeFetchingCounter: fetchingCounter,
      isFetching: !(fetchingCounter === 0),
    },
  };
}

export function fetchImpressionsAllCampaignsFail(state, error) {
  const fetchingCounter = state.impressionsReports.activeFetchingCounter - 1;
  const errorMessage =
    error.message ? error.message : 'Request failed. Open the browser console for details.';
  return {
    ...state,
    impressionsReports: {
      ...state.impressionsReports,
      activeFetchingCounter: fetchingCounter,
      isFetching: !(fetchingCounter === 0),
      fetchingErrorMessages: [...state.impressionsReports.fetchingErrorMessages, errorMessage],
    },
  };
}

export function fetchImpressionsStatistics(state, { filter }) {
  return {
    ...state,
    impressionsReports: {
      ...state.impressionsReports,
      filter: filter || state.impressionsReports.filter,
      activeFetchingCounter: state.impressionsReports.activeFetchingCounter + 1,
      fetchingErrorMessages: [],
      isFetching: true,
    },
  };
}

export function fetchImpressionsStatisticsSuccess(state, statistics) {
  const fetchingCounter = state.impressionsReports.activeFetchingCounter - 1;
  return {
    ...state,
    impressionsReports: {
      ...state.impressionsReports,
      statistics,
      activeFetchingCounter: fetchingCounter,
      isFetching: !(fetchingCounter === 0),
    },
  };
}

export function fetchImpressionsStatisticsFail(state, error) {
  const fetchingCounter = state.impressionsReports.activeFetchingCounter - 1;
  const errorMessage =
    error.message ? error.message : 'Request failed. Open the browser console for details.';
  return {
    ...state,
    impressionsReports: {
      ...state.impressionsReports,
      activeFetchingCounter: fetchingCounter,
      isFetching: !(fetchingCounter === 0),
      fetchingErrorMessages: [...state.impressionsReports.fetchingErrorMessages, errorMessage],
    },
  };
}



/** WEBPACK FOOTER **
 ** ./js/core/impressionsReports.js
 **/